import { render, staticRenderFns } from "./NavBarList.vue?vue&type=template&id=ef650a28&scoped=true&"
import script from "./NavBarList.vue?vue&type=script&lang=js&"
export * from "./NavBarList.vue?vue&type=script&lang=js&"
import style0 from "./NavBarList.vue?vue&type=style&index=0&id=ef650a28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef650a28",
  null
  
)

export default component.exports